"use client"

import { ThemeProvider } from "@/components/theme-provider"
import { Provider as JotaiProvider } from 'jotai'
import { useEffect } from 'react'
import Clarity from '@microsoft/clarity'

/**
 * Providers
 *
 * Envolve a aplicação nos seguintes provedores:
 * - JotaiProvider: gerencia estado global via jotai
 * - ThemeProvider: gerencia temas claro/escuro (biblioteca next-themes)
 *
 * ThemeProvider Props:
 * - attribute? (string): atributo HTML para classe de tema (default 'class')
 * - defaultTheme? (string): tema padrão (default 'light')
 * - enableSystem? (boolean): habilita preferência do sistema (default false)
 *
 * Inicializa Microsoft Clarity se NEXT_PUBLIC_CLARITY_ID estiver definida.
 *
 * Exemplo de alternância de tema:
 * ```tsx
 * import { useTheme } from 'next-themes'
 *
 * function ThemeSwitcher() {
 *   const { theme, setTheme } = useTheme()
 *   return (
 *     <button onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}>
 *       Alternar tema para {theme === 'light' ? 'escuro' : 'claro'}
 *     </button>
 *   )
 * }
 * ```
 *
 * @param children Conteúdo React a ser renderizado
 */
export function Providers({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_CLARITY_ID) {
      Clarity.init(process.env.NEXT_PUBLIC_CLARITY_ID)
    }
  }, [])

  return (
    <JotaiProvider>
      
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
        {children}
      </ThemeProvider>
    </JotaiProvider>
  )
} 